import React, {InputHTMLAttributes} from 'react';

import cn from 'classnames';
import omit from 'lodash/omit';

import bem from 'client/services/bem';

import Icon from 'client/common/icon';

import LoadingSpinner from 'client/components/common/loading-spinner';

import {Translation} from 'client/models/language/types';
import {ObjectValues} from 'client/types/common';

import {POSITION_OPTIONS} from './constants';

import cssModule from './toggle-input.module.scss';

type iconConfig = {
  name?: string;
  width?: number;
  height?: number;
  size?: number;
  color?: string;
  className?: string;
};

type DeprecatedProps = {
  /** deprecated - doesn't work anymore */
  rounded?: boolean;
  /** deprecated - doesn't work anymore */
  color?: string;
  /** deprecated - doesn't work anymore */
  borderColor?: string;
  /** deprecated - doesn't work anymore */
  backgroundColor?: string;
};

type Props = DeprecatedProps & {
  label?: Translation;
  labelPosition?: ObjectValues<typeof POSITION_OPTIONS>;
  className?: string;
  classNames?: {
    label?: string;
  };
  checked?: boolean;
  disabled?: boolean;
  loading?: boolean;
  title?: string;
  size?: 'sm' | 'md';
  checkedIconConfig?: iconConfig;
  uncheckedIconConfig?: iconConfig;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'checked' | 'disabled' | 'size'>;

const b = bem('toggle-input', {cssModule});

const ToggleInput: React.FC<Props> = (props) => {
  const {
    label = '',
    labelPosition = POSITION_OPTIONS.LEFT,
    onChange,
    className = '',
    classNames = {},
    checked,
    disabled,
    loading,
    title = '',
    size = 'md',
    checkedIconConfig,
    uncheckedIconConfig,
    ...inputProps
  } = props;

  const hasCheckedIcon = checkedIconConfig || uncheckedIconConfig;

  return (
    <label className={cn(b({'has-checked-icons': !!hasCheckedIcon}), className)}>
      {label && <span className={cn(b('text', [labelPosition]), classNames?.label)}>{label}</span>}
      <input
        type="checkbox"
        className={b('input')}
        onChange={loading ? undefined : onChange}
        checked={checked}
        disabled={disabled}
        {...omit(inputProps)}
      />
      <div
        className={b('toggle', {
          checked,
          disabled,
          loading,
          [size]: true,
          'has-checked-icons': !!hasCheckedIcon,
        })}
        title={title}
      >
        {loading && (
          <div className={b('loader-wrap')}>
            <LoadingSpinner className={b('loader')} loading />
          </div>
        )}
        {hasCheckedIcon && (
          <div className={b('icon-wrapper')}>
            {checked && checkedIconConfig?.name && (
              <Icon {...(checkedIconConfig as {name: string; size?: number; color?: string})} />
            )}
            {!checked && uncheckedIconConfig?.name && (
              <Icon {...(uncheckedIconConfig as {name: string; size?: number; color?: string})} />
            )}
          </div>
        )}
      </div>
    </label>
  );
};

export default ToggleInput;
